import type { ReactNode } from "react";
import { BackButton } from "@/components/common/BackButton";

export function ShareDetailLayout({ id, graphql, status, metadata, comments, children }: {
  id?: string; graphql: string; status?: ReactNode; metadata?: ReactNode; comments?: ReactNode; children?: ReactNode;
}) {
  const columns = metadata && comments
    ? "@lg:grid-cols-[minmax(220px,280px)_minmax(0,1fr)_minmax(260px,320px)]"
    : metadata ? "@lg:grid-cols-[minmax(220px,280px)_minmax(0,1fr)]" : "";
  return <main id={id} className="w-full max-w-[1600px] px-4 pb-12 pt-6 @sm:px-6 @lg:px-10" data-graphql={graphql}>
    <div className="mb-5"><BackButton /></div>
    {status || <div className={`grid grid-cols-1 gap-6 @lg:items-start ${columns}`}>
      {metadata}{children}{comments}
    </div>}
  </main>;
}
